import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Home from '../../okta/Home';
import envConfig from '../../environments/envConfig';
import UserPreferences from './UserPrefereces';
import StorePicker from './stores/StorePicker';

const UserAvatar = props => {
  const userPreferencesModal = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [hideAdminOption, hideAdmin] = useState(true);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const showUserPrefrences = () => {
    handleClose();
    userPreferencesModal.current();
  };
  const hideAdminMenuItem = () => {
    hideAdmin(false);
  };
  const showAdminMenuItem = () => {
    hideAdmin(true);
  };
  const navigateToAdminUi = () => {
    const environment = process.env.REACT_APP_ENV;
    const adminUrl = envConfig[environment].REACT_APP_ADMINURL;
    window.location = adminUrl;
  };
  return (
    <section>
      <div className="user-settings">
        <IconButton
          className="three-dots-ico"
          aria-label="more"
          id="long-button"
          aria-controls="long-menu"
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <Avatar className="cfa-avatar">CP</Avatar>
        </IconButton>
        <Menu
          className="dropdown"
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          elevation={0}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem
            id="show-userPreferences"
            className="cfa-dropdown-item"
            onClick={(handleClose, showUserPrefrences)}
          >
            User Preferences
          </MenuItem>
          <Divider sx={{ my: 0.5 }} />
          {hideAdminOption && (
            <section>
              <MenuItem
                className="cfa-dropdown-item"
                onClick={(handleClose, navigateToAdminUi)}
              >
                Admin
              </MenuItem>

              <MenuItem
                className="cfa-dropdown-item"
                onClick={() => {
                  hideAdminMenuItem();
                  handleClose();
                }}
              >
                Hide admin options
              </MenuItem>
            </section>
          )}
          {!hideAdminOption && (
            <section>
              <MenuItem
                className="cfa-dropdown-item"
                onClick={() => {
                  showAdminMenuItem();
                  handleClose();
                }}
              >
                Show admin options
              </MenuItem>
            </section>
          )}

          <Divider sx={{ my: 0.5 }} />
          <MenuItem className="cfa-dropdown-item" onClick={handleClose}>
            <Home />
          </MenuItem>
        </Menu>
        <UserPreferences userPreferencesModal={userPreferencesModal} />
      </div>
      <div className="store-picker-original">
        <StorePicker />
      </div>
    </section>
  );
};

export default UserAvatar;
